import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '@app-core/services/storage/storage.service';
import { LoginTypes } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { DataService } from '@app-core/services/data/data.service';
import { AccessService } from '@app-core/services/access/access.service';

@Component({
  selector: 'app-oauth-login',
  templateUrl: './oauth-login.component.html',
  styleUrls: ['./oauth-login.component.scss'],
})
export class OAuthLoginComponent implements OnInit {
  constructor(
    private storageService: StorageService,
    private dataService: DataService,
    private accessService: AccessService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.checkSession();
  }

  private checkSession() {
    const loginInfo = this.storageService.getStorageValue('loginInfo');
    this.accessService.setLoginInfo(loginInfo);

    const redirectPath = this.route.snapshot.queryParamMap.get('redirect_path') || 'home';
    this.dataService.userLogin.next({ loginInfo, redirectUrl: redirectPath, loginType: LoginTypes.fleetManager });
  }
}
